import { render, staticRenderFns } from "./AlCheckbox.vue?vue&type=template&id=260a019c&"
import script from "./AlCheckbox.vue?vue&type=script&lang=js&"
export * from "./AlCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./AlCheckbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports